<script setup lang="ts">
</script>
<template>
  <the-layout hide-navbar>
    <div class="flex flex-col items-center p-6 md:mx-auto md:my-6 md:max-w-md md:rounded md:bg-white">
      <img
        src="@/assets/icons/warning-alt.svg"
        class="size-24"
      >
      <p class="mt-2 text-center font-medium text-z-gray-900">
        Ha ocurrido un error al inscribir tu cuenta. <br>
        Por favor inténtalo nuevamente.
      </p>
      <base-button
        href="/perfil/solicitudes_reservas/cliente#esperando-pago"
        class="mt-6 w-full"
      >
        Volver a mis solicitudes
      </base-button>
      <base-button
        variant="secondary"
        href="/"
        class="mt-4 w-full"
      >
        Volver al inicio
      </base-button>
    </div>
  </the-layout>
</template>
